import './App.css';
import * as THREE from "three";
import { Canvas, useFrame, useThree, useLoader, extend } from "@react-three/fiber";
import { Stats, OrbitControls, Billboard, Text, useTexture } from '@react-three/drei';
import React, { Suspense, useMemo, useRef, useEffect, useState } from "react";
import Prisms from "./Background.js";

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

extend({ EffectComposer, ShaderPass, RenderPass, UnrealBloomPass });


function Effect() {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 3, 0.5, 0]} />
    </effectComposer>
  )
}

function CameraMovement() {
  const { scene, camera } = useThree();
  const ref = useRef();
  let posX = 0;


  useFrame(({clock, mouse}) => {
    posX += left / 100 - right / 100;
    let time = clock.getElapsedTime() * 5;
    camera.position.copy(new THREE.Vector3(posX, 5, time));
    ref.current.position.copy(new THREE.Vector3(posX, 5, time - 10));
    camera.lookAt(new THREE.Vector3(posX, 2, time + 5));

    score = Math.round(clock.getElapsedTime() - reset.value);
  })
  return (
    <pointLight position={[0, 10, 0]} intensity={0.8} ref={ref}/>
    );
}

var left = false;
var right = false;
var score = 0, reset = {value: 0};

function downHandler({key})
{

  if(key === "ArrowLeft" || key === "a")
  {
    left = true;
  }
  else if(key === "ArrowRight" || key === "d")
  {
    right = true;
  }
}


function upHandler({key})
{

  if(key === "ArrowLeft" || key === "a")
  {
    left = false;
  }
  else if(key === "ArrowRight" || key === "d")
  {
    right = false;
  }
}


const Model = () => {
  
  const { scene, camera } = useThree();

  const gltf = useLoader(GLTFLoader, './spaceship.glb');
  let tilt = 0;
  useEffect(() => {
    gltf.scene.children[0].material = new THREE.MeshBasicMaterial({color: 0x3E2233});
  })

  useFrame(({clock, mouse}) => {
    if(tilt <= Math.PI / 2)
      tilt += left / 100;
    if(tilt >= -Math.PI / 2)
      tilt -= right / 100;
    gltf.scene.position.copy(camera.position.clone().add(new THREE.Vector3(0,-2, 2)));
    // console.log(tiltUp)
    gltf.scene.children[0].rotation.set(0.51, 0, tilt);
    if(!left && !right)
      tilt *= 0.9;
  });

  return (
    <primitive object={gltf.scene} scale={[0.1,0.1,0.1]} />
  );
};

class Score extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      val: 0
    };
  }
  
  componentDidMount() {
    this.interval = setInterval(() => {this.setState(state => ({val: score}))}, 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {

    return(
    <div style={{color: 'white', position: 'absolute', left: '50%', top: '90%', zIndex: 2, transform: 'translate(-50%, 0px)', fontSize: '50px'}}>
      {this.state.val}
    </div>)
  }
}


const useAudio = url => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing]
  );

  useEffect(() => {
    // audio.muted = true;
    audio.addEventListener('ended', function () {
      this.play();
    }, false);
  }, []);

  return [playing, toggle];
};

const Player = ({ url }) => {
  const [playing, toggle] = useAudio(url);

  return (
    <div>
      {playing ? <img src="./playing.png" alt="unmute" onClick={toggle} width={20} height={20}  style={{position: 'absolute', zIndex: 2}}/> : 
                 <img src="./mute.png" alt="mute" onClick={toggle}  width={20} height={20} style={{position: 'absolute', zIndex: 2}}/> }
    </div>
  );
};

function App(){

  
  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
  })

  return (
    
    <div style={{width: '100vw', height: '100vh', overflowX: 'hidden'}}>
      <Score />
      <Player url={"song.mp3"} />
    <Canvas>
      <Effect />
      <fog attach="fog" args={["black", 0.1, 30]} />
      <CameraMovement />

      <Prisms i={40} j={40} maxSize={0.9} wireframe={false} col={0x1E0233} height={0} reset={reset}/>
      <Prisms i={40} j={40} maxSize={0.92} wireframe={true} col={0x1E0233} height={8}/>
      
      <Suspense fallback={null}>
        <Model />
      </Suspense>
      
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0,-5,0]} layers={0} name={'plane'}>
        <planeGeometry args={[1000000, 1000000]} />
        <meshBasicMaterial color="black" visible={false}/>
      </mesh>


      {/* <OrbitControls /> */}
      {/* <Stats /> */}
    </Canvas>
    </div>
  );
}

export default App;
